// extracted by mini-css-extract-plugin
export default {"fade_in":"Menu_fade_in__rNiIP","fade-in":"Menu_fade-in__qvpmm"};